import React, { useState, useEffect } from 'react'
import { Spinner } from '@telavita-core/react-design-kit'

import { PatientDetailProfessionalModal } from 'containers/ModalManager/Modals/PatientDetailProfessionalModal'
import { PatientCancellationsModal } from 'containers/ModalManager/Modals/PatientCancellationsModal'

import { 
  GraphicsDropdown,
  getRangeDays,
  SelectedDate,
  lastDay
} from 'components/GraphicsDropdown'

import { 
  PatientsEmptyMessage, 
  PatientFooter, 
  PatientsTable, 
  PatientsHeader 
} from './components'

import { GraphicsCard } from 'components/GraphicsCard'

import { CANCELED, PATIENT_NO_SHOW } from 'settings/_scheduleStatusSettings'
import { SCHEDULE_CANCEL_BY_PACIENT } from 'settings/_reasonsSettings'
import { rangeDateFilterOptions } from 'settings/_filterSettings'

import { useTableData } from './hooks/useTableData'

import { IPatient } from './types'

import { Content, Loading } from './styles'

const DATA_LENGTH = 5

export function PatientCancellations(): JSX.Element {
  const initialOption = rangeDateFilterOptions[1]
  const [activeTab, setActiveTab] = useState(0)
  const [patients, setPatients] = useState<IPatient[]>([])
  const [itemsToShow, setItemsToShow] = useState(DATA_LENGTH)
  const [showPatientCancellationsModal, setShowPatientCancellationsModal] = useState(false)

  const [patientDetailModal, setPatientDetailModal] = useState({
    show: false,
    patient: {
      email: '',
      name: '',
      phone: '',
    }
  })
  
  const [selectedDate, setSelectedDate] = useState<SelectedDate>({
    initialDate: getRangeDays(initialOption.quantity).toString(),
    endDate: lastDay.toString(),
  })
  
  const { fetchScheduleDataByStatus, data, loading } = useTableData()

  useEffect(() => {
    fetchScheduleDataByStatus({
      selectedDate,
      statusCode: activeTab === 0 ? PATIENT_NO_SHOW : CANCELED,
      reasonCode: activeTab === 0 ? null : [SCHEDULE_CANCEL_BY_PACIENT],
    })
  }, [activeTab, selectedDate, fetchScheduleDataByStatus])

  useEffect(() => {
    if (data.length) {
      setPatients(data.slice(0, itemsToShow))
    }

    return () => {
      setPatients([])
    }
  }, [data, itemsToShow])

  function handleChangeTab(_, value) {
    setActiveTab(value)
  }

  function handleOpenPatientDetailModal(patient: IPatient) {
    setPatientDetailModal(prevState => ({
      ...prevState,
      show: true,
      patient: {
        ...patient,
      }
    }))
  }

  function showMorePatients() {
    setItemsToShow(prevState => prevState + DATA_LENGTH) 
  }

  return (
    <>
      <GraphicsCard
        id='sectionAbsencesAndCancellations'
        title={<>Faltas / <br />Cancelamentos</>}
        headerAction={
          <GraphicsDropdown 
            initialOption={initialOption}
            onSelectedDate={setSelectedDate}
          />
        }
      >
        <main>
          <PatientsHeader activeTab={activeTab} onChangeTab={handleChangeTab} />
          <Content>
            
            {loading && (
              <Loading>
                <Spinner />
              </Loading>
            )}
           
            <PatientsEmptyMessage 
              showEmptyMessage={!patients.length && !loading} 
              activeTab={activeTab} 
            />
          
            <PatientsTable 
              activeTab={activeTab}
              patients={patients}
              loading={loading}
              onClickPatient={handleOpenPatientDetailModal}
            />

            <PatientFooter 
              isEmpty={!patients.length}
              disabled={patients.length === data.length}
              onClickOnSeeMore={showMorePatients}
              onClickOnShowModal={() => setShowPatientCancellationsModal(true)}
            />
          </Content>
        </main>
        
      </GraphicsCard>
      {patientDetailModal.show && (
        <PatientDetailProfessionalModal
          email={patientDetailModal.patient.email}
          name={patientDetailModal.patient.name}
          phone={patientDetailModal.patient.phone}
          onClose={() => setPatientDetailModal(prevState => ({
            ...prevState,
            show: false,
          }))}
        />
      )}
      {showPatientCancellationsModal && (
        <PatientCancellationsModal 
          onClose={() => setShowPatientCancellationsModal(false)}
        />
      )}
    </>
  )
}